import { ApolloLink, from } from '@apollo/client'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import errorLink from './logApolloError'
import reportErrors from './reportErrors'
import roundTripLink from './roundTripLink'
import { terminalLinkv2, terminalLinkv3 } from './terminalLinks'
import GQLmonitor from './utils/GQLmonitor'

const generateDirectionalLink = (
  onError: (error?: string) => void,
  router?: AppRouterInstance,
  otherCustomLinks: ApolloLink[] = []
) => {
  const baseLink = [
    errorLink(onError, router),
    roundTripLink(GQLmonitor),
    ...otherCustomLinks,
    reportErrors(onError),
  ]

  const linkv2 = from([...baseLink, terminalLinkv2])
  const linkv3 = from([...baseLink, terminalLinkv3])

  return ApolloLink.split(
    (operation) => operation.getContext().version === 'v3',
    linkv3,
    linkv2
  )
}

export default generateDirectionalLink
